import React from "react";
import ReadSciences from "../components/science/ReadSciences";

export default function Sciences() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold col-span-12">Fanlar</h1>
      <ReadSciences />
    </div>
  );
}
